import React, { useState, useRef, useEffect } from "react";
import Task from "../task/Task";
import "./Project.css";
import { useDispatch, useSelector } from "react-redux";
import { Draggable, Droppable } from "react-beautiful-dnd";
import { addTodoToFirebase } from "../../redux/actions/TodoManipulation/addTodoToFirebaseAction";
import { toggleShowAddTaskInput } from "../../redux/actions/showAddTaskInputAction";
import { toggleShowProjectContextMenu } from "../../redux/actions/showProjectContextMenuAction";
import ContextMenu from "../contextMenu/ContextMenuComponent";
import { findByIdInTreeList } from "../../utils/tree";
import AiModalComponent from "../aiModal/AiModalComponent";
import AiMessageModalComponent from "../aiMessageModal/AiMessageModal";
import DatePickerModalComponent from "../datePickerModal/datePickerModal";
import dayjs from "dayjs";
import { editTaskInFirebase } from "../../redux/actions/TodoManipulation/editTaskInFirebaseAction";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";
import { useNavigate, useLocation } from "react-router-dom";
import { deleteTaskFromFirebase } from "../../redux/actions/TodoManipulation/deleteTaskFromFirebaseAction";
import DeleteModal from '../editModal/DeleteModal';

const Project = (props) => {
    const {
        project,
        idx,
        zoomLevel,
        isProjectDragging,
        currentlyDraggedProjectId,
    } = props;
    const { title, children, type } = project;
    const projectDueDate = dayjs(project.dueDate).format('ll');
    const childrenCount = children ? children.length : 0;
    const dispatch = useDispatch();
    const moreButtonRef = useRef(null);
    const [showAiModal, setShowAiModal] = useState(false);
    const [showDateModal, setShowDateModal] = useState(false);
    const [showAiMessageModal, setShowAiMessageModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [disableButtons, setDisableButtons] = useState(true);
    const [dateType, setDateType] = useState('');
    const [todoId, setTodoId] = useState('');
    const [todoTitle, setTodoTitle] = useState('');
    const [todoChildren, setTodoChildren] = useState('');
    const showAddTaskInput = useSelector(
        (state) => state.showAddTaskInput[project.$id]
    );
    const showProjectContextMenu = useSelector(
        (state) => state.showProjectContextMenu[project.$id]
    );
    const isMobile = useIsMobile();
    const aiAssistant = useSelector((state) => state.userSettings.aiAssistant);
    const selectedDate = useSelector((state) => state.selectedDate.date);
    const showDueDate = useSelector((state) => state.userSettings.showDueDate);
    const showVisualSize = useSelector((state) => state.userSettings.showVisualSize);
    const [hiddenDate, setHiddenDate] = useState('');
    const [notificationDate, setNotificationDate] = useState('');
    const [dueDate, setDueDate] = useState('');
    const [modalOpenDate, setModalOpenDate] = useState(dayjs());
    const [isHoverWand, setIsHoveredWand] = useState(false);
    const handleInputToggle = (projectId) => {
        dispatch(toggleShowAddTaskInput(projectId));
    };
    const handleMouseEnterWand = () => {
        setIsHoveredWand(true);
    };

    const [content, setContent] = useState("");
    const navigate = useNavigate();
    const currentLocation = useLocation();

    const openAiModal = () => {

        if (!content) return;

        if (aiAssistant) {
            setShowAiModal(true);
        } else {
            setShowAiMessageModal(true);
        }
    };
    const closeAiModal = () => {
        setShowAiModal(false);

        if (content.length > 0) {
            setDisableButtons(false);
        } else {
            setDisableButtons(true);
        }
    };

    const openDateModal = (dateType, title, todo) => {
        setDateType(dateType);
        setTodoId(todo.id);
        setTodoTitle(title);

        switch (dateType) {
            case "hidden":
                todo.snoozedUntil ? setModalOpenDate(todo.snoozedUntil) : setModalOpenDate(null);
                break;
            case "notification":
                todo.notificationDate ? setModalOpenDate(todo.notificationDate) : setModalOpenDate(null);
                break;
            case "dueDate":
                todo.dueDate ? setModalOpenDate(todo.dueDate) : setModalOpenDate(null);
                break;
        }

        setShowDateModal(true);
    };

    const closeDateModal = () => {
        setShowDateModal(false);
    };

    const clearDateModal = () => {
        setShowDateModal(false);

        switch (dateType) {
            case "hidden":
                setHiddenDate('');
                const json = {
                    id: todoId,
                    HasSnoozedUntil: "true",
                    SnoozedUntil: ''
                }
                dispatch(editTaskInFirebase(json));
                break;
            case "notification":
                setNotificationDate('');
                break;
            case "dueDate":
                setDueDate('');
                break;
        }
        setModalOpenDate('');
    };

    const saveDate = async () => {
        setShowDateModal(false);
        let updatedDate = null;
        if (selectedDate === '') {
            updatedDate = dayjs().format();
        }
        else {
            updatedDate = selectedDate;
        }
        switch (dateType) {
            case "hidden":
                setHiddenDate(updatedDate);

                const json = {
                    id: todoId,
                    HasSnoozedUntil: "true",
                    SnoozedUntil: updatedDate
                }

                await dispatch(editTaskInFirebase(json));

                break;
            case "notification":
                setNotificationDate(updatedDate);
                break;
            case "dueDate":
                setDueDate(updatedDate);
                break;
        }
    };

    const closeAcceptAiMessageModal = () => {
        setShowAiMessageModal(false);

        setShowAiModal(true);
    };

    const closeRejectAiMessageModal = () => {
        setShowAiMessageModal(false);

        if (content.length > 0) {
            setDisableButtons(false);
        } else {
            setDisableButtons(true);
        }
    };

    const handleAddTaskChange = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); 
            const title = event.target.value;
            if (title !== "") {
                handleAddTask(title);
                setContent("");
            }
        }
        else if (event.key === 'Escape') {
            setContent("");
            handleInputToggle(project.$id);
        }
        else {
            if (event.key !== 'Enter') {
                setContent(event.target.value);
            }
        }

        if (event.target.value) {
            setDisableButtons(false);
        } else {
            setDisableButtons(true);
        }

    }

    const handleLearnMore = () => {
        window.open('https://support.texthelp.com/help/smart-task-assistant', '_blank', 'noopener,noreferrer');
    }

    const handleAddTask = async (textContent) => {
        const json = {
            title: textContent,
            parentId: project.id,
            type: "0",
            dueDate: dueDate,
            notificationDate: notificationDate
        }

        await dispatch(
            addTodoToFirebase(json)
        );
        const inputElement = document.querySelector(".add-task-title");
        if (inputElement) {
            inputElement.focus();
        }
        setDueDate('');
        setNotificationDate('');
    };

    const toggleContextMenu = (projectId) => {
        dispatch(toggleShowProjectContextMenu(projectId));
    };
    const projects = useSelector((state) => state.taskList.data);
    const toggleShowModal = (projectId, event) => {
        const allowedClassNames = [
            "gw-icon-button",
            "gt-task__completed",
            "gw-icon-button__icon",
            "gw-task-hide",
            "MuiButtonBase-root",
            "MuiSvgIcon-root",
            "MuiClock-squareMask",
            "MuiTypography-root",
            "gw-button"
        ];

        if (!allowedClassNames.some(className => event.target.classList.contains(className))) {
            const todoItem = findByIdInTreeList(projects, projectId);
            dispatch({ type: "TOGGLE_EDIT_MODAL", payload: { todo: todoItem } });
        }
    };

    const toggleShowDateModal = (dateType, title, todo) => {
        setTodoId(todo.id);
        setTodoTitle(title);
        openDateModal(dateType, title, todo);
    };

    const toggleShowDeleteModal = (todo) => {
        setTodoId(todo.id);
        setTodoTitle(todo.title);
        setTodoChildren(todo.children ? todo.children.length : 0);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setShowDeleteModal(false);
    };

    const deleteTask = async () => {
        const json = { id: todoId };
        await dispatch(deleteTaskFromFirebase(json));
        setShowDeleteModal(false);
    };

    const getTaskColor = () => {
        if (project && project.color) {
            return project.color.hexString;
        } else {
            return "#80C3E9";
        }
    };
    const [taskColor, setTaskColor] = useState(getTaskColor());

    useEffect(() => { setTaskColor(getTaskColor()); }, [project]);

    const isDragDisabled =
        isProjectDragging &&
        type === "1" &&
        project.$id === currentlyDraggedProjectId;

    return (
        <div style={{ fontSize: isMobile ? '10px' : `${zoomLevel}px` }}>
            <DatePickerModalComponent
                modalOpen={showDateModal}
                onClose={closeDateModal}
                onClear={clearDateModal}
                onSave={() => saveDate()}
                type={dateType}
                todoTitle={todoTitle}
                date={modalOpenDate}
            ></DatePickerModalComponent>
            <AiMessageModalComponent
                modalOpen={showAiMessageModal}
                onCloseAccept={closeAcceptAiMessageModal}
                onCloseReject={closeRejectAiMessageModal}
            ></AiMessageModalComponent>
            <AiModalComponent
                modalOpen={showAiModal}
                onClose={closeAiModal}
                todoTitle={content}
                parentId={project.id}
                newTodo={true}
            ></AiModalComponent>
            <DeleteModal
                modalOpen={showDeleteModal}
                onClose={closeDeleteModal}
                onDelete={deleteTask}
                todoTitle={todoTitle}
                children={todoChildren > 0 ? true : false}
            ></DeleteModal>
            <Draggable
                draggableId={project.$id}
                index={idx}
                isDragDisabled={isDragDisabled}
            >
                {(provided) => (
                    <div
                        className="gt-project"
                        {...provided.draggableProps}
                        ref={provided.innerRef}
                    >
                        <div className="gt-project__colour" style={{ backgroundColor: taskColor ? taskColor : "#80C3E9" } }></div>
                        <div className="gt-project__header" {...provided.dragHandleProps} onClick={(event) => toggleShowModal(project.id, event)}
                            style={{marginBottom: '0'} }                        >
                            {/*<svg xmlns="http://www.w3.org/2000/svg" style={{*/}
                            {/*    height: '22px',*/}
                            {/*    margin: '12px 12px 12px 12px',*/}
                            {/*    width: '22px',*/}
                            {/*}}>*/}
                            {/*    <use xlinkHref="#globaltasks-svg-folder"></use>*/}
                            {/*</svg>*/}
                            <h5>{title}</h5>
                            <p>({childrenCount})</p>
                            <button
                                className="gw-icon-button gw-icon-button--icon"
                                aria-label="hide"
                                onClick={() => {
                                    openDateModal("hidden", project.title, project);
                                }}
                            >
                                <i className="gw-icon-button__icon gw-button__icon--eye"></i>
                            </button>
                            {showProjectContextMenu && (
                                <div className={isMobile ? ''
                                    : "gt-context-menu-activator gt-context-menu-activator--bottom-right"}>
                                    <ContextMenu
                                        todoId={project.id}
                                        type={project.type}
                                        parent={project.parent}
                                        todo={project}
                                        toggleShowModal={toggleShowModal}
                                        toggleShowDeleteModal={toggleShowDeleteModal}
                                    ></ContextMenu>
                                </div>
                            )}
                            <div className="project-context-menu">
                                <button
                                    className="gw-icon-button gw-icon-button--icon"
                                    aria-label="more"
                                    onClick={(event) => {
                                        toggleContextMenu(project.$id);
                                    }}
                                    ref={moreButtonRef}
                                >
                                    <i className="gw-icon-button__icon gw-button__icon--more"></i>
                                </button>
                            </div>
                        </div>
                        <Droppable droppableId={project.$id} type="task" isCombineEnabled>
                            {(provided) => (
                                <div
                                    className="task-container"
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                >
                                    <span>
                                        <div className="gt-task__tags" style={{ paddingBottom: '1.5em', marginLeft: '1.5em', paddingTop: '0' }}>
                                            {(showDueDate && project.dueDate) && (
                                                <div className="gt-task-tag">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xlinkHref="#globaltasks-svg-calendar"></use>
                                                    </svg>
                                                    <p>{projectDueDate}</p>
                                                </div>)}
                                            {(showVisualSize && project.visualSize !== 0) && (
                                                <div className="gt-task-tag gt-task-tag--align-right">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        {project.visualSize === 1 && (
                                                            <use xlinkHref="#globaltasks-svg-effort-medium"></use>
                                                        )}
                                                        {project.visualSize === 2 && (
                                                            <use xlinkHref="#globaltasks-svg-effort-large"></use>
                                                        )}
                                                    </svg>
                                                </div>)}
                                        </div>
                                        <div>
                                            {children !== null &&
                                                children !== undefined &&
                                                children
                                                .slice()
                                                .sort((a, b) => {
                                                    // Sort by siblingOrder for tasks within a section (Overview page)
                                                    // But fallback to globalPriority if siblingOrder values are the same (legacy data)
                                                    const aSiblingOrder = a.siblingOrder || 0;
                                                    const bSiblingOrder = b.siblingOrder || 0;
                                                    
                                                    // If both have the same siblingOrder, fallback to globalPriority
                                                    if (aSiblingOrder === bSiblingOrder) {
                                                        if (a.globalPriority !== null && b.globalPriority !== null) {
                                                            return a.globalPriority - b.globalPriority;
                                                        } else if (a.globalPriority === null) {
                                                            return 1;
                                                        } else {
                                                            return -1;
                                                        }
                                                    }
                                                    
                                                    return aSiblingOrder - bSiblingOrder;
                                                })
                                                .map((task, index) => (
                                                    <Task
                                                        key={task.$id}
                                                        task={task}
                                                        taskIndex={index}
                                                        zoomLevel={zoomLevel}
                                                        isProjectDragging={isDragDisabled}
                                                        toggleShowModal={toggleShowModal}
                                                        toggleShowDateModal={toggleShowDateModal}
                                                        toggleShowDeleteModal={toggleShowDeleteModal}
                                                        parent={project}
                                                    />
                                                ))}
                                        </div>
                                    </span>
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                        {!showAddTaskInput ? (
                            <button
                                className="gt-project__add-task"
                                onClick={() => handleInputToggle(project.$id)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg">
                                    <use xlinkHref="#globaltasks-svg-add"></use>
                                </svg>
                                Add new task
                            </button>
                        ) : (
                                <div className="gt-add-task" style={{ fontSize: isMobile ? '10px' : `${zoomLevel}px` } }>
                                <div 
                                    className="gt-add-task__title"
                                >
                                    <textarea
                                        className="add-task-title"
                                        type="text"
                                        value={content}
                                        onChange={handleAddTaskChange}
                                        placeholder="Add a new task"
                                        onKeyDown={handleAddTaskChange}
                                        autoFocus={true}
                                    />
                                    </div>

                                    <div className="gt-task__tags" style={{paddingBottom: 10} }>
                                        { dueDate && (<div className="gt-task-tag">
                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                <use xlinkHref="#globaltasks-svg-calendar"></use>
                                            </svg>
                                            <p>{dayjs(dueDate).format('ll')}</p>
                                        </div>)}
                                        {notificationDate && (<div className="gt-task-tag">
                                            <svg xmlns="http://www.w3.org/2000/svg">
                                                <use xlinkHref="#globaltasks-svg-notification"></use>
                                            </svg>
                                            <p>{dayjs(notificationDate).format('ll')}</p>
                                        </div>)}
                                    </div>

                                    <div className="gt-add-task__controls">
                                        {/*<a data-tooltip-id="tooltip-dueDate">*/}
                                        <button className="gw-icon-button" aria-label="set due date"
                                            onClick={() => {
                                                openDateModal("dueDate", project.title, project);
                                            }}                                        >
                                        <i className="gw-icon-button__icon gw-button__icon--calendar"></i>
                                            </button>
                                        {/*</a>*/}
                                        {/*<Tooltip id="tooltip-dueDate">Set a Due date</Tooltip>*/}
                                        {/*<a data-tooltip-id="tooltip-notificationDate">*/}
                                    <button
                                        className="gw-icon-button"
                                            aria-label="add notification"
                                            onClick={() => {
                                                openDateModal("notification", project.title, project);
                                            }}
                                    >
                                        <i className="gw-icon-button__icon gw-button__icon--notification"></i>
                                        </button>
                                    {/*</a>*/}
                                    {/*    <Tooltip id="tooltip-notificationDate">Set a Notification date</Tooltip>*/}
                                        {/*<a data-tooltip-id="tooltip-wand">*/}
                                            <button className="gw-icon-button" aria-label="Help break with down"
                                                disabled={disableButtons}
                                                onClick={() => {
                                                    openAiModal();
                                                }}
                                            onMouseEnter={handleMouseEnterWand}
                                            >
                                                <i className="gw-icon-button__icon gw-button__icon--ai"></i>
                                            </button>
                                        {/*</a>*/}
                                        {/*<Tooltip id="tooltip-wand">Magic wand</Tooltip>*/}
                                    <button
                                        className="gw-button gw-button--s1"
                                        onClick={() => {
                                            setContent("");
                                            setDisableButtons(true);
                                            handleInputToggle(project.$id);
                                            clearDateModal();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="gw-button gw-button--s1 gw-button--primary"
                                        disabled={disableButtons}
                                        onClick={() => {

                                            if (content.trim() !== "") {
                                                handleAddTask(content);
                                                setDisableButtons(true);
                                                setContent("");
                                            }
                                        }}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </Draggable>
            {/*{(isHoverWand && !aiAssistant) && (*/}
            {/*    <div class="gw-infopopup gw-infopopup" style={{ width: "300px" }}>*/}
            {/*        <div class="gw-infopopup__header">*/}
            {/*            <h5>Help me break this down</h5>*/}
            {/*        </div>*/}
            {/*        <div class="gw-infopopup__body">*/}
            {/*            <p>Click the magic wand and Global Tasks will break the task down into subtasks for you, like magic!</p>*/}
            {/*        </div>*/}
            {/*        <div class="gw-infopopup__footer gw-group gw-group--align-right">*/}
            {/*            <button type="button" class="gw-button  gw-button--link"*/}
            {/*                onClick={() => handleLearnMore()}*/}
            {/*            >Learn more</button>*/}
            {/*            <button type="button" class="gw-button  gw-button--link"*/}
            {/*                onClick={() => setIsHoveredWand(false)}*/}
            {/*            >Got it</button>*/}
            {/*        </div>*/}
            {/*    </div>)}*/}
            </div>

    );
};

export default Project;
